<template>
  <div>
    <div v-show="showButton" class="section operations  align-right">
      <div v-show="cooperateEdit" class="triggers">
        <cargo-button-group-slider>
          <div>
            <el-button no="New" type="primary" @click="onAdd">{{ $t('SeaExport.New') }}</el-button>
            <el-button no="Edit" type="primary" :disabled="!btnEnable.btnEdit" @click="onEdit">{{ $t('SeaExport.Edit') }}</el-button>
            <el-button no="Delete" type="danger" :disabled="!btnEnable.btnRemove" @click="onRemove">{{ $t('SeaExport.Delete') }}</el-button>
            <el-button no="Clone" type="primary" :disabled="!btnEnable.btnClone" @click="onClone">{{ $t('SeaExport.Clone') }}</el-button>
            <el-button no="Send2" type="primary" :disabled="!btnEnable.btnSend" @click="onSend">{{ $t('SeaExport.Send2') }}</el-button>
            <el-button v-if="btnVisible.btnBack" no="Back" type="primary" :disabled="!btnEnable.btnBack" @click="onBack">{{ $t('SeaExport.Back') }}</el-button>
            <el-button no="SendBack" type="primary" :disabled="!btnEnable.btnReturn" @click="onReturn">{{ $t('SeaExport.SendBack') }}</el-button>
            <el-button no="ExpressInfo" type="primary" :disabled="!btnEnable.btnInfo" @click="onExInfo">{{ $t('SeaExport.ExpressInfo') }}</el-button>
            <el-button no="PrintReceipt" type="success" @click="onReceipt">{{ $t('SeaExport.PrintReceipt') }}</el-button>
            <el-button no="PrintChargebackList" type="success" @click="onPrint">{{ $t('SeaExport.PrintChargebackList') }}</el-button>
          </div>
        </cargo-button-group-slider>
      </div>
    </div>

    <div class="section grid-wrapper">
      <cargo-ag-grid
        config-module="130128"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width:100%;min-height: 350px"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
    <!-- 列点击后详情页 -->
    <div class="section file-from-bg">
      <el-form label-width="140px" class="file-form">
        <el-form-item :label="$t('SeaExport.FileType')" class="custom">
          <cargo-advance-select
            filterable
            :select-type="selectTypeNames.basic_data_TransmitFileType"
            :default-value="selectedFile.fileType"
            style="width:400px;"
            :disabled="true"
          />
        </el-form-item>
        <el-form-item v-if="fileView.txtCheckStatusOfCustomsDeclaration" class="label-none custom">
          <el-button style="text-decoration: underline;border: 0;" @click="stateQueryClickHandler">{{ this.$t('SeaExport.CheckStatusOfCustomsDeclaration') }}</el-button>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.TenBitCode')" class="custom">
          <el-input v-model="selectedFile.tenDigitCode" no="tenDigitCode" :readonly="true" style="width:400px" maxlength="10" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.ReceiverCompanyName')" class="custom">
          <el-input v-model="selectedFile.receiveCompany" no="receiveCompany" :readonly="true" style="width:400px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Tel')" class="custom">
          <el-input v-model="selectedFile.receiveTel" no="receiveTel" :readonly="true" style="width:400px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.CustomsDeclarationPages')" class="custom">
          <el-input v-model="selectedFile.customsPageNumber" no="customsPageNumber" :readonly="true" style="width:300px" :disabled="true" />
          <el-checkbox v-model="selectedFile.customsTransfer" no="customsTransfer" :disabled="true" style="width:100px;padding-left:10px">{{ $t('SeaExport.CustomsTransitOrNot') }}</el-checkbox>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.CustomsBroker')" class="custom">
          <cargo-company-select
            :disabled="true"
            :method-params="{customsBroker:true,seaExport:true,active:true}"
            :default-value="selectedFile.customsBroker||''"
            style="width:300px;display:inline-block;"
            @change="p=>{selectedFile.customsBroker=p.value}"
          />
          <el-checkbox v-model="selectedFile.tax" no="tax" :disabled="true" style="width:100px;padding-left:10px;">{{ $t('SeaExport.TakeByCustomsBroker') }}</el-checkbox>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.ExpressAddress')" class="custom">
          <el-input
            v-model="selectedFile.expressAddress"
            no="expressAddress"
            type="textarea"
            :rows="3"
            :readonly="true"
            style="width:400px;"
            :disabled="true"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.ExpressAddress'),selectedFile.expressAddress,val=>{selectedFile.expressAddress=val})"
          />
        </el-form-item>
      </el-form>
      <el-form label-width="140px" class="file-form">
        <el-form-item :label="$t('SeaExport.FileNo')" class="custom">
          <el-input v-model="selectedFile.fileNo" no="fileNo" :readonly="true" style="width:400px" :disabled="true" />
        </el-form-item>
        <el-form-item v-if="fileView.checkPreRecordedCustomsDeclaration" class="label-none custom">
          <el-dropdown
            split-button
            type="primary"
            trigger="click"
            @command="onLogPopUpMenu"
          >
            {{ fileView.command }}
            <el-dropdown-menu v-for="item in fileView.buttonArry" :key="item.id" slot="dropdown">
              <el-dropdown-item :command="item.value">{{ item.value }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.OperatingCompany')" class="custom">
          <el-input v-model="selectedFile.companyCname" no="companyCname" :readonly="true" style="width:400px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Receiver2')" class="custom">
          <el-input v-model="selectedFile.receivePerson" no="receivePerson" :readonly="true" style="width:400px" :disabled="true" />
        </el-form-item>
        <el-form-item v-if="this.job && this.job.lob === 'SE'" :label="$t('SeaExport.Addr')" class="custom">
          <el-input v-model="selectedFile.receiveAddress" no="receiveAddress" :readonly="true" style="width:400px" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.TradeMethod')" class="custom">
          <el-input v-model="selectedFile.tradeModeName" no="tradeModeName" :readonly="true" style="width:400px" :disabled="true" />
        </el-form-item>
        <el-form-item v-show="selectedFile.fileType==='3'" :label="$t('SeaExport.DateOfDeclaration')">
          <el-date-picker
            v-model="selectedFile.declareDate"
            no="declareDate"
            type="date"
            value-format="yyyy-MM-dd"
            :disabled="true"
            style="width:400px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Remarks')" class="custom">
          <el-input
            v-model="selectedFile.remark"
            no="remark"
            type="textarea"
            :rows="3"
            :readonly="true"
            style="width:400px;"
            :disabled="true"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),selectedFile.remark,val=>{selectedFile.remark=val})"
          />
        </el-form-item>
      </el-form>
    </div>

    <!-- 单证送出弹窗 -->
    <el-dialog
      v-el-drag-dialog
      no="DocumentDelivery"
      :visible.sync="sendOutDialog.visible"
      :title="$t('SeaExport.DocumentDelivery')"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-form label-width="65px" label-position="left">
        <el-radio-group v-model="sendOutDialog.customerType" class="custom" @change="sendOutCustomTypeChange()">
          <el-radio :label="0">{{ $t('SeaExport.bookingParty') }}</el-radio>
          <el-radio :label="1">{{ $t('SeaExport.Customer') }}</el-radio>
          <el-radio :label="2">{{ $t('SeaExport.CustomsBrokerOthers') }}</el-radio>
        </el-radio-group>
        <el-form-item :label="$t('SeaExport.ReceiverCompanyName')">
          <el-input v-model="sendOutDialog.formData.receiveCompany" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Receiver2')">
          <el-input v-model="sendOutDialog.formData.receivePerson" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.ReceivingAddress')">
          <el-input v-model="sendOutDialog.formData.receiveAddress" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.ContactNumber')">
          <el-input v-model="sendOutDialog.formData.receiveTel" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_CourierOrderNo')">
          <el-input v-model="sendOutDialog.formData.expressNo" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="sendOutPrint">{{ $t('SeaExport.print') }}</el-button>
        <el-button type="primary" @click="sendOutSend">{{ $t('SeaExport.Send2') }}</el-button>
        <el-button @click="sendOutDialog.visible=false">{{ $t('SeaExport.Cancel') }}</el-button>
      </div>
    </el-dialog>

    <!-- 单证取回弹窗 -->
    <el-dialog
      v-el-drag-dialog
      no="takeBackDialog"
      :visible.sync="takeBackDialog.visible"
      :title="takeBackDialog.dataLabelTitle"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-form label-width="100px" label-position="left">
        <el-form-item :label="takeBackDialog.dataLabel">
          <el-date-picker
            v-model="takeBackDialog.backDate"
            type="date"
            :clearable="false"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="takeBackSave">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="takeBackDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>

    <!-- 单证退还弹窗 -->
    <el-dialog
      v-el-drag-dialog
      no="BatchPrint"
      :visible.sync="returnDialog.visible"
      :title="$t('SeaExport.BatchPrint')"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-form label-width="80px" label-position="left">
        <el-form-item :label="$t('SeaExport.Customer')">
          <el-input v-model="returnDialog.formData.companyCName" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Receiver2')">
          <el-input v-model="returnDialog.formData.receiver" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.ContactNumber')">
          <el-input v-model="returnDialog.formData.tel" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.ExpressAddress')">
          <el-input
            v-model="returnDialog.formData.address"
            type="textarea"
            :rows="3"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.ReturnExpressNumber')">
          <el-input v-model="returnDialog.formData.expressNo" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.ReturnDate')">
          <el-date-picker
            v-model="returnDialog.formData.returnDate"
            type="date"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="returnPrintHandler(true)">{{ $t('SeaExport.print') }}</el-button>
        <el-button type="primary" @click="returnPrintHandler(false)">{{ $t('SeaExport.Chargeback') }}</el-button>
        <el-button @click="returnCancle">{{ $t('SeaExport.Cancel') }}</el-button>
      </div>
    </el-dialog>

    <!-- 快递信息弹窗 -->
    <el-dialog
      v-el-drag-dialog
      no="fastMailDialog"
      :visible.sync="fastMailDialog.visible"
      :title="$t('CargoMsg.Cargo_ExpressInfo')"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-form label-width="85px" label-position="left">
        <el-form-item :label="$t('SeaExport.ReceiverCompanyName')">
          <el-input v-model="this.fastMailDialog.exprssInfo.sendReceiveCompany" :readonly="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Receiver2')">
          <el-input v-model="this.fastMailDialog.exprssInfo.sendReceivePerson" :readonly="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.ReceivingAddress')">
          <el-input v-model="this.fastMailDialog.exprssInfo.sendExpressAddress" :readonly="true" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.ContactNumber')">
          <el-input v-model="this.fastMailDialog.exprssInfo.sendReceiveTel" :readonly="true" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_CourierOrderNo')">
          <el-input v-model="this.fastMailDialog.exprssInfo.sendExpressNo" :readonly="true" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="fastMailDialog.visible=false">{{ $t('SeaExport.Close') }}</el-button>
      </div>
    </el-dialog>

    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="advanceTextDialog"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-input v-model="advanceTextDialog.value" type="textarea" rows="10" />
      <span slot="footer">
        <el-button type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>

    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />

    <!-- 文件编辑弹框 -->
    <file-dialog ref="fileDialog" :visible.sync="editDialog.visible" :selected-file="selectedFile" :job="job" @successHandler="successHandler" />

    <!-- 退单文件弹框 -->
    <customs-info-file-dialog ref="customsInfoFile" :visible.sync="customsInfoFiledialog.visible" :model="customsInfoFiledialog.model" :category="customsInfoFiledialog.category" />

    <!--报关状态-->
    <el-dialog
      v-el-drag-dialog
      no="StatusOfCustomsDeclaration"
      :visible.sync="fileView.isCustomsStatusTitle"
      :title="$t('SeaExport.StatusOfCustomsDeclaration')"
      width="600px"
      :close-on-click-modal="false"
    >
      <cargo-ag-grid
        config-module="130129"
        :grid-options="gridOptionsCustomsStatus"
        :column-defs="columnDefsCustomsStatus"
        :row-data="rowDataCustomsStatus"
        style="width:100%;height: 300px"
        @gridReady="params=>{gridApiFileDetail=params.api}"
      />
      <span slot="footer">
        <el-button @click="fileView.isCustomsStatusTitle=false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { cache } from '@/utils/cacheManager'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { fileList, updateBatchFile, delFile, checkChargeWriteoffClear, findKeyForCustoms, getGetCustomsStatusResult, getCustomsStatusURL } from '@/api/seaExport/file'
import { Company } from '@/class/model/mdm/Company'
import { File } from '@/class/model/booking/File'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { DocumentManage } from '@/utils/commonUtil'
import fileDialog from '@/components/Cargo/Job/fileDialog'
import CustomsInfoFileDialog from '@/components/Cargo/Job/customsInfoFileDialog'
import * as DocumentConstants from '@/class/cargo/model/parameters/DocumentConstants'
import * as TransmitFileType from '@/class/cargo/model/parameters/TransmitFileTypeConstants'
import { stateQueryClickHandler } from '@/class/cargo/model/utils/file'
import { sortByMultiField } from '@/utils'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { User } from '@/class/model/sys/User'

export default {
  name: 'TabFile',
  components: { CargoButtonGroupSlider, CustomsInfoFileDialog, cargoAdvanceSelect, cargoTemplateSelectorDialog, fileDialog, cargoCompanySelect },
  props: {
    context: {
      type: Object,
      required: true
    },
    showButton: {
      type: Boolean,
      required: false,
      default: true
    },
    viewSource: { // 页面请求发起方
      type: String,
      required: false
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: null,
      partnerManagementMode: 0,
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null
      },
      selectTypeNames: TYPE_NAMES,
      TransmitFileType,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onCellFocused(event)
        },
        onSelectionChanged: event => {
          this.checkButtonsState()
        },
        onRowClicked: this.onRowClicked
      },
      role: {
        viewUser: this.$checkPermission(['role_File_viewUser']),
        viewDep: this.$checkPermission(['role_File_viewDep']),
        viewAll: this.$checkPermission(['role_File_viewAll']),
        editUser: this.$checkPermission(['button_File_editUser']),
        editDep: this.$checkPermission(['button_File_editDep']),
        editAll: this.$checkPermission(['button_File_editAll']),
        departmentTeamUser: [] // 当前用户同部门
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.FileType'),
          field: 'uuid',
          width: 120,
          cellRenderer: (params) => {
            return this.convertFileTypeNameByCodeLob(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.FileNo'),
          field: 'fileNo',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.CustomsNo'),
          field: 'customsNo',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.DateOfCreation'),
          field: 'receiveDate',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.SendingDate'),
          field: 'sendDate',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.SendingExpressNumber'),
          field: 'sendExpressNo',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.ReceivingDate'),
          field: 'backDate',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Receiver'),
          field: 'backUser',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', parseInt(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.ReturnDate'),
          field: 'returnDate',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.ReturnExpressNumber'),
          field: 'returnExpressNo',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.DateOfDeclaration'),
          field: 'declareDate',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.FileStatus'),
          field: 'state',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.fileStateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CreatedBy'),
          field: 'inputBy',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', parseInt(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Dep'),
          field: 'inputByDep',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', parseInt(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.ViewFile'),
          field: 'originFileId',
          width: 120,
          cellRenderer: params => {
            const methodPath = this.documentManage.getPath('showFileDetailHandler')
            if (params.value) {
              return `<a onclick="${methodPath}('${params.value}')" style="text-decoration: underline;">${this.$t('SeaExport.ChargebackFile')}</a>`
            }
          }
        }
      ],
      rowData: [],
      gridApi: null,
      gridApiFileDetail: null,
      rowDataCustomsStatus: [],
      gridOptionsCustomsStatus: {
        context: {
          componentParent: this
        }
      },
      columnDefsCustomsStatus: [
        {
          headerName: this.$t('SeaExport.ReceiptTime'),
          field: 'RECEIPT_DATE',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.ReceiptContent'),
          field: 'RECEIPT_CONTENT',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.ReceiveReceiptTime'),
          field: 'DATE_CREATED',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.receiptCode'),
          field: 'RECEIPT_CODE',
          width: 100
        }
      ],
      fastMailDialog: {
        visible: false,
        exprssInfo: {
        }
      },
      takeBackDialog: {
        visible: false,
        dataLabel: '',
        dataLabelTitle: '',
        backDate: '',
        startDate: '',
        selectableRange: ''
      },
      sendOutDialog: {
        visible: false,
        sendType: 1,
        customerType: 1,
        printFlag: false,
        formData: {
          receiveCompany: '',
          receivePerson: '',
          receiveAddress: '',
          receiveTel: '',
          expressNo: ''
        }
      },
      editDialog: {
        visible: false
      },
      customsInfoFiledialog: {
        visible: false,
        model: null,
        category: null
      },
      returnDialog: {
        visible: false,
        printFlag: false,
        formData: {
          companyCName: '',
          receiver: '',
          tel: '',
          address: '',
          expressNo: '',
          returnDate: ''
        }
      },
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: new SeaExportJob(),
        category: 'JOBLIST',
        data: {
          JOB_UUID: [],
          LOB: 'SE'
        }
      },
      btnVisible: {
        btnBack: true
      },
      btnEnable: {
        btnEdit: true,
        btnRemove: true,
        btnInfo: true,
        btnClone: true,
        btnSend: true,
        btnReturn: true,
        btnBack: true
      },
      job: {},
      currentUser: {},
      selectedFile: {},
      selectedFiles: [],
      isLockFileType: true,
      bgdHp: false,
      checkSubmitFileBack: false,
      enablePrint: false,
      documentManage: new DocumentManage(),
      pickerOptions: { // 设置可选时间范围
        disabledDate: this.disabledDate
      },
      fileView: {
        isCustomsStatusTitle: false,
        txtCheckStatusOfCustomsDeclaration: false,
        checkPreRecordedCustomsDeclaration: false,
        command: '',
        customsDeclarationUrl: '',
        releaseNoticeUrl: '',
        buttonArry: []
      }
    }
  },

  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return !this.isEdit
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look' && (!this.form.uuid || this.form.state < 2)
    },
    config() {
      return this.context.config
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('showFileDetailHandler', function(value) {
      context.showFileDetailHandler(value)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  async created() {
    this.loading = getLoading4Cxt(this)
    try {
      await this.context.prepareData(true)
      this.partnerManagementMode = Number(this.config.get('PartnerManagementMode')) // 是否启用合作伙伴管理模式
    } finally {
      this.loading.close()
    }
  },
  methods: {
    async onShow(row, isRefresh) {
      if (isRefresh) {
        this.currentUser = cache.user
        this.job = row
        // 根据当前用户权限加载文件
        this.role.departmentTeamUser = await User.getUserDepartmentTeam()
        await this.reloadFileHandler()
        this.checkSubmitFileBack = parseInt(cache.config.get('BookingSubmitFileBack')) === 0
        this.checkUserRole()
        this.loadSuccess()
      }
    },
    async showFileDetailHandler() {
      let customsInfo = null
      await findKeyForCustoms(this.job.uuid).then(res => { customsInfo = res.data })

      this.customsInfoFiledialog.model = customsInfo
      this.customsInfoFiledialog.category = DocumentConstants.UPLOAD_ORDER_BACK
      this.customsInfoFiledialog.visible = true
    },
    checkUserRole() {
      this.btnVisible.btnBack = this.currentUser.admin || this.$checkPermission(['button_BookingFileBack_file'])
    },
    loadSuccess() {
      this.selectedFile = new File().fillDefaultValue().getData()
      if (!this.job) return
      if (this.rowData) {
        if (this.rowData.length > 0) {
          this.onSelectionChanged()
        } else {
          this.checkButtonsState()
        }
      } else {
        this.checkButtonsState()
      }
    },
    // 重置按扭状态
    checkButtonsState() {
      this.selectedFiles = this.gridOptions.api.getSelectedRows()

      if (this.selectedFile.uuid) {
        this.btnEnable.btnEdit = this.selectedFile.state <= 1 || this.$checkPermission(['button_ACFile_CRFileEdit'])
        this.btnEnable.btnRemove = this.selectedFile.state < 2 || this.$checkPermission(['button_ACFile_CRFileEdit'])
        this.enablePrint = this.selectedFile.state > 0
        this.btnEnable.btnInfo = this.selectedFile.state > 0
        this.btnEnable.btnClone = true
      } else {
        this.btnEnable.btnEdit = false
        this.btnEnable.btnRemove = false
        this.enablePrint = false
        this.btnEnable.btnInfo = false
        this.btnEnable.btnClone = false
        this.btnEnable.btnReturn = false
      }
      this.btnEnable.btnSend = false
      this.btnEnable.btnBack = false

      if (this.selectedFiles.length > 0) {
        let ok = true
        let canReturn = true
        for (const f of this.selectedFiles) {
          if (f.state > 1) { ok = false }
          if (f.state !== 2) {
            canReturn = false
          }
        }
        this.btnEnable.btnSend = ok
        this.btnEnable.btnBack = true
        this.btnEnable.btnReturn = canReturn
      }
    },
    onSelectionChanged(fileId) {
      this.setGridSelect(fileId)
      this.checkButtonsState()
      this.loadUrl()
      this.showTradeMode()
    },
    // 设置 选中行
    setGridSelect(fileId) {
      const nodes = this.gridApi.getRenderedNodes()
      this.selectedFile = null
      if (fileId) {
        for (const item of nodes) {
          if (fileId === item.data.fileId) {
            item.setSelected(true)
            this.selectedFile = item.data
            return
          }
        }
      }
      if (!this.selectedFile) {
        // 默认选中第一个
        for (const item of nodes) {
          item.setSelected(true)
          this.selectedFile = item.data
          return
        }
      }
      // 默认值
      this.selectedFile = new File().fillDefaultValue().getData()
    },
    async loadFile(type) {
      await fileList(this.job.uuid).then(res => {
        let list = []
        if (res.data) {
          if (type === 0) {
            list = res.data
          } else if (type === 1) {
            // 查看同组权限，根据部门筛选
            for (const file of res.data) {
              if (this.checkDepartmentTeam(file)) {
                list.push(file)
              }
            }
          } else if (type === 2) {
            // 只有查看自己权限，仅展示录入人是自己
            for (const file of res.data) {
              if (file.inputBy === this.$store.getters.userId) {
                list.push(file)
              }
            }
          }
          this.rowData = list
        }
      })
    },
    checkDepartmentTeam(file) {
      if (!file.inputBy || file.inputBy === this.$store.getters.userId) {
        return true
      }
      for (const userId of this.role.departmentTeamUser) {
        if (userId === file.inputBy) {
          return true
        }
      }

      return false
    },
    onRowClicked(event) {
      // this.selectedFile = event.data
      // this.checkButtonsState()
      // this.loadUrl()
      // this.showTradeMode()
    },
    onCellFocused(event) {
      if (this.gridOptions.api && event.column) {
        this.gridOptions.api.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            this.selectedFile = node.data
          }
        })
      }
      this.checkButtonsState()
      this.loadUrl()
      this.showTradeMode()
    },
    async loadUrl() {
      let soNo = ''
      // url置空，防止因为缓存显示不正常
      this.fileView.checkPreRecordedCustomsDeclaration = false
      this.fileView.releaseNoticeUrl = ''
      this.fileView.customsDeclarationUrl = ''
      if (this.selectedFile != null && this.selectedFile.fileType === '3') {
        if (this.job.lob === 'SE') {
          soNo = this.job.soNo
        } else if (this.job.lob === 'AE' || this.job.lob === 'SI' || this.job.lob === 'AI') {
          soNo = this.selectedFile.fileNo
        }
        if (soNo) {
          await this.getYLDUrlResult()
        }
      }
    },
    getYLDUrlResult() {
      getCustomsStatusURL(this.selectedFile).then(res => this.getURLResultHandler(res.data))
    },
    getURLResultHandler(value) {
      if (!value) return
      const url1 = value['releaseNotice']
      const url2 = value['customsDeclaration']
      console.log(url1)
      console.log(url2)

      if (!(!url1 && !url2)) {
        this.fileView.checkPreRecordedCustomsDeclaration = true
        // 动态设置下拉框
        if (url2) {
          this.fileView.customsDeclarationUrl = url2
          this.fileView.buttonArry.push({ id: 1,
            value: this.$t('SeaExport.CheckPreRecordedCustomsDeclaration') })
        }
        if (url1) {
          this.fileView.releaseNoticeUrl = url1
          this.fileView.buttonArry.push({ id: 2,
            value: this.$t('SeaExport.CheckRecordedCustomsDeclaration') })
        }
        this.fileView.command = this.fileView.buttonArry[0].value
      }
    },
    onLogPopUpMenu(val) {
      if (parseInt(cache.config.get('CustomerStatusQueryModel')) === 0) {
        this.findCustomerServiceByName(0)
      } else {
        switch (val) {
          case this.$t('SeaExport.CheckPreRecordedCustomsDeclaration'):
            if (this.fileView.customsDeclarationUrl.indexOf('http://') < 0) {
              this.$message.info(this.fileView.customsDeclarationUrl)
              return
            }
            window.open(this.fileView.customsDeclarationUrl)
            break
          case this.$t('SeaExport.CheckRecordedCustomsDeclaration'):
            if (this.fileView.releaseNoticeUrl.indexOf('http://') < 0) {
              this.$message.info(this.fileView.releaseNoticeUrl)
              return
            }
            window.open(this.fileView.releaseNoticeUrl)
            break
        }
      }
    },
    showTradeMode() {
      if (this.selectedFile.tradeMode === 1) {
        this.selectedFile.tradeModeName = this.$t('Message.GeneralTrade')
      } else if (this.selectedFile.tradeMode === 2) {
        this.selectedFile.tradeModeName = this.$t('Message.ProcessingWithSuppliedMaterial')
      } else if (this.selectedFile.tradeMode === 3) {
        this.selectedFile.tradeModeName = this.$t('Message.ProcessingTrade')
      } else if (this.selectedFile.tradeMode === 4) {
        this.selectedFile.tradeModeName = this.$t('Message.SamplesOfAdvertisingProductsA')
      // } else if (this.selectedFile.tradeMode === 5) {
      //   this.selectedFile.tradeModeName = this.$t('SeaExport.OtherImportsFree')
      }
      const interchangeCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_TransmitFileType, 'code', this.selectedFile.fileType, 'interchangeCode')
      const str = interchangeCode === TransmitFileType.BGD_TYPE
      this.fileView.txtCheckStatusOfCustomsDeclaration = str
    },
    // 报关状态查询
    async stateQueryClickHandler() {
      const queryModel = parseInt(cache.config.get('CustomerStatusQueryModel'))
      const bExcute = await stateQueryClickHandler(queryModel, this.selectedFile, this.job)
      if (!bExcute) return
      await getGetCustomsStatusResult(this.selectedFile).then(res => {
        this.getGetCustomsStatusResultHander(res.data)
      }
      )
    },
    getGetCustomsStatusResultHander(data) {
      this.fileView.isCustomsStatusTitle = true
      this.rowDataCustomsStatus = sortByMultiField(data, ['RECEIPT_DATE'], true)
    },
    // 添加单证
    onAdd() {
      if (this.job == null) {
        this.$message.info(this.$t('Message.TheBookingDoesNotExistAndCannotBeAdded'))
      } else {
        this.$nextTick(() => {
          this.editDialog.visible = true
          this.$refs.fileDialog.onShow('add')
        })
      }
    },
    onEdit() {
      if (!this.selectedFile) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (!this.checkEdit()) {
        this.$message.warning(this.$t('Message.YouToEditTheAdministrator'))
        return
      }
      this.editDialog.visible = true
      this.$refs.fileDialog.onShow('edit')
    },
    onClone() {
      if (!this.selectedFile) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (!this.checkEdit()) {
        this.$message.warning(this.$t('Message.YouToEditTheAdministrator'))
        return
      }
      this.editDialog.visible = true
      this.$refs.fileDialog.onShow('clone')
    },
    async successHandler(fileId) {
      this.selectedFile = {}

      await this.reloadFileHandler()
      this.$nextTick(() => {
        this.onSelectionChanged(fileId)
      })
    },
    // 批量取回
    onBack() {
      const rows = this.gridApi.getSelectedRows()
      if (rows === null || rows.length === 0) return
      for (const file of rows) {
        if (!this.checkEdit(file)) {
          this.$message.warning(this.$t('Message.YouToEditTheAdministrator'))
          return
        }
      }
      this.takeBackDialog.visible = true
      this.takeBackDialog.dataLabel = this.$t('Message.GetBack') + this.$t('CargoMsg.Cargo_Date')
      this.takeBackDialog.dataLabelTitle = this.$t('SeaExport.Documents') + this.$t('Message.GetBack')
      this.takeBackDialog.dataField = 'sendDate'

      // 赋值 日期区间
      let minDate = null
      for (const file of rows) {
        if (!minDate) {
          minDate = file[this.takeBackDialog.dataField]
        } else if (file[this.takeBackDialog.dataField] && minDate.time > file[this.takeBackDialog.dataField].time) {
          minDate = file[this.takeBackDialog.dataField]
        }
      }
      this.takeBackDialog.startDate = minDate
      this.takeBackDialog.backDate = new Date()
      this.takeBackDialog.selectableRange = { 'rangeStart': minDate }
    },
    // 批量取回 -保存
    takeBackSave() {
      if (this.takeBackDialog.backDate) {
        const selectedFiles = this.gridApi.getSelectedRows()
        for (const file of selectedFiles) {
          file.state = 2
          file.backDate = this.takeBackDialog.backDate
          file.backUser = this.currentUser.userId
        }
        // 调用后端保存
        updateBatchFile(selectedFiles).then(res => {
          const params = { jobUuid: this.job.uuid, event: 'back_file_charge_writeoff' }
          checkChargeWriteoffClear(params)
          // todo 刷新 job 上的 rackingInfo
          // _job.reloadTrackingInfo
          this.$message.success(this.$t('CargoMsg.Cargo_GoBackSuccess'))
          this.takeBackDialog.visible = false
          this.successHandler(this.selectedFile.fileId)
        })
      }
    },
    // =============================送出 begin==================================
    onSend() {
      if (!this.checkEdit()) {
        this.$message.warning(this.$t('Message.YouToEditTheAdministrator'))
        return
      }
      this.sendOutDialog.visible = true
      this.sendOutDialog.sendType = 0
      this.sendOutDialog.customerType = this.sendOutDialog.sendType
      this.sendOutDialog.formData.expressNo = this.selectedFile.sendExpressNo
      this.sendOutCustomTypeChange()
    },
    sendOutPrint() {
      if (!this.sendOutCheckForm()) return

      this.sendOutDialog.printFlag = true
      this.sendOutSend()
    },
    sendOutSend() {
      if (!this.sendOutCheckForm()) return

      const selectedFiles = this.gridApi.getSelectedRows()
      for (const file of selectedFiles) {
        file.sendReceiveCompany = this.sendOutDialog.formData.receiveCompany
        file.sendReceivePerson = this.sendOutDialog.formData.receivePerson
        file.sendExpressAddress = this.sendOutDialog.formData.receiveAddress
        file.sendReceiveTel = this.sendOutDialog.formData.receiveTel
        file.sendExpressNo = this.sendOutDialog.formData.expressNo
        file.SendBy = this.currentUser.userId
        file.sendDate = new Date()
        file.state = 1
      }
      updateBatchFile(selectedFiles).then(res => {
        if (this.sendOutDialog.printFlag) {
          this.sendOutDoPrint()
        } else {
          this.$message.success(this.$t('Message.SentOut'))
        }
        this.sendOutDialog.visible = false
        this.successHandler(this.selectedFile.fileId)
      })
      // todo 重新加载 reloadTrackingInfo
      // _job.reloadTrackingInfo(new mx.rpc.Responder(function(e:ResultEvent):void{},function(f:FaultEvent):void{}));
    },
    sendOutDoPrint() {
      const params = {}
      params.FILE_UUID = this.selectedFile.uuid
      params.USER_ID = this.currentUser.userId
      this.templateSelectorDialog.cxt = new File(this.selectedFile)
      this.templateSelectorDialog.category = 'FILE'
      this.templateSelectorDialog.data = params
      this.templateSelectorDialog.visible = true
      // TemplateSelectorWin.getInstance().showThisWin(file, "FILE", params, this);
    },
    sendOutCheckForm() {
      let warning = ''
      if (!this.sendOutDialog.formData.receiveCompany) {
        warning = this.$t('SeaExport.InputReceivingcompany')
      } else if (!this.sendOutDialog.formData.receivePerson) {
        warning = this.$t('SeaExport.InputRecipient')
      } else if (!this.sendOutDialog.formData.receiveAddress) {
        warning = this.$t('SeaExport.InputReceivingAddress')
      } else if (!this.sendOutDialog.formData.receiveTel) {
        warning = this.$t('SeaExport.InputContactNumber')
      } else if (!this.sendOutDialog.formData.expressNo) {
        warning = this.$t('SeaExport.InputExpressNumber')
      }
      if (warning) {
        this.$message.warning(warning)
        return false
      }
      return true
    },
    sendOutCustomTypeChange() {
      this.sendOutDialog.formData.receiveCompany = ''
      this.sendOutDialog.formData.receiveAddress = ''
      this.sendOutDialog.formData.receivePerson = ''
      this.sendOutDialog.formData.receiveTel = ''
      // this.sendOutDialog.formData.expressNo = ''
      switch (this.sendOutDialog.customerType) {
        case 0:
          this.setByCompanyId(this.job.bookingAgent)
          break
        case 1:
          this.setByCustomerId(this.job.customerId)
          break
        case 2:
          this.setByCompanyId(this.sendOutDialog.sendType === 2 ? this.job.customsBroker : this.selectedFile.customsBroker)
          break
      }
    },
    async setByCustomerId(cmpIdx) {
      let company = { cmpIdx: cmpIdx }
      company = new Company(company)
      if (company != null) {
        const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', cmpIdx)
        if (!companyCache) {
          return
        }
        this.sendOutDialog.formData.receiveCompany = companyCache.chineseName
        this.sendOutDialog.formData.receiveAddress = companyCache.address
        const contacts = await company.getContactsBycmpIdx()
        let contact = null
        // 获取业务上的联系人，若业务上无 则取默认联系人
        if (contacts) {
          for (const item of contacts) {
            if (item.contactPerson === this.job.customerContact) {
              contact = item
              break
            }
          }
          if (!contact) {
            for (const item of contacts) {
              if (item.defaultContact) {
                contact = item
                break
              }
            }
          }
        }
        console.log(contact)
        if (contact) {
          this.sendOutDialog.formData.receivePerson = contact.contactPerson
          this.sendOutDialog.formData.receiveTel = contact.telephone
        }
      }
    },
    async setByCompanyId(cmpIdx) {
      const companyCache = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', cmpIdx)
      if (!companyCache) {
        return
      }
      this.sendOutDialog.formData.receiveCompany = companyCache.chineseName
      this.sendOutDialog.formData.receiveAddress = companyCache.address
      let company = { cmpIdx: cmpIdx }
      company = new Company(company)
      let contact = null
      if (company != null) {
        const contacts = await company.getContactsBycmpIdx()
        if (contacts) {
          for (const item of contacts) {
            if (item.defaultContact) {
              contact = item
              break
            }
          }
          if (contact) {
            this.sendOutDialog.formData.receivePerson = contact.contactPerson
            this.sendOutDialog.formData.receiveTel = contact.telephone
          }
        }
      }
    },
    // =============================送出 end==================================
    // =============================退还 begin==================================
    onReturn() {
      this.selectedFiles = this.gridApi.getSelectedRows()
      if (!this.selectedFiles || this.selectedFiles.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      for (const file of this.selectedFiles) {
        if (!this.checkEdit(file)) {
          this.$message.warning(this.$t('Message.YouToEditTheAdministrator'))
          return
        }
      }
      const blocks = this.getCreditFileSetting()
      if (blocks.hasOwnProperty('back') && blocks['back'] === '1') {
        if (this.job.blocked) {
          this.$message.warning(this.$t('SeaExport.BusinessIsLocked'))
          return
        }
      }
      if (this.checkSubmitFileBack && (this.job.jobState < 1 || this.job.jobState === 13)) {
        this.$message.warning(this.$t('SeaExport.BusinessNotSubmitted'))
        return
      }
      let state = -1
      for (const file of this.selectedFiles) {
        if (state === -1) {
          state = file.state
        }
        if (file.state !== 2 && file.state !== 3) {
          this.$message.warning(this.$t('SeaExport.BusinessNotSubmitted'))
          return
        } else if (state !== file.state) {
          this.$message.warning(this.$t('SeaExport.SameStatusCanBePrinted'))
          return
        }
      }
      if (this.job.jobState !== 2) {
        this.$confirm(this.$t('SeaExport.BusinessNotBeenApproved'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => this.prePrint())
      } else {
        this.prePrint()
      }
    },
    prePrint() {
      this.returnDialog.formData.returnDate = new Date()
      if (this.selectedFiles === null || this.selectedFiles.length === 0) return
      const file = this.selectedFiles[0]
      this.returnDialog.formData.companyCName = file.receiveCompany
      this.returnDialog.formData.receiver = file.receivePerson
      this.returnDialog.formData.tel = file.receiveTel
      this.returnDialog.formData.address = file.expressAddress
      this.returnDialog.formData.expressNo = file.returnExpressNo
      this.returnDialog.visible = true
    },
    returnCancle() {
      this.$confirm(this.$t('Message.SureYouWantToCancel'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => { this.returnDialog.visible = false })
    },
    returnPrintHandler(isPrint) {
      if (!this.returnValidate()) return
      const customer = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', this.job.customerId)
      if (customer && customer.address !== this.returnDialog.formData.address) {
        this.$confirm(this.$t('CargoMsg.Cargo_MANMWCSAISCTD'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => { this.returnDoPrint(isPrint) })
      } else {
        this.returnDoPrint(isPrint)
      }
    },
    returnDoPrint(isPrint) {
      if (isPrint) {
        let msg = this.$t('CargoMsg.Cargo_SureToPrint')
        const map = {}

        for (const file of this.selectedFiles) {
          map[file.state] = true
        }
        if (map.hasOwnProperty(2) && map.hasOwnProperty(3)) {
          msg += this.$t('SeaExport.ClickYesRetrievedToReturnedStatus')
        } else if (map.hasOwnProperty(2)) {
          msg += this.$t('SeaExport.ClickYesToReturnedStatus')
        }
        this.$confirm(msg, this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          this.returnUpdateFiles(isPrint)
        })
      } else {
        this.returnUpdateFiles(isPrint)
      }
    },
    async returnUpdateFiles(isPrint) {
      for (const file of this.selectedFiles) {
        file.receiveCompany = this.returnDialog.formData.companyCName
        file.receivePerson = this.returnDialog.formData.receiver
        file.receiveTel = this.returnDialog.formData.tel
        file.expressAddress = this.returnDialog.formData.address
        file.returnExpressNo = this.returnDialog.formData.expressNo
        file.state = 3// 已退还
        file.returnDate = this.returnDialog.formData.returnDate
        file.returnPerson = this.currentUser.userId
      }
      await updateBatchFile(this.selectedFiles).then(() => {
        if (isPrint) {
          const f = this.selectedFiles[0]
          const params = { 'FILE_UUID': f.uuid, 'USER_ID': this.currentUser.userId }
          console.log(this.$t('SeaExport.PrintCommonControls'))
          this.templateSelectorDialog.category = 'FILERETURN'
          this.templateSelectorDialog.cxt = new File(f)
          this.templateSelectorDialog.data = params
          this.templateSelectorDialog.visible = true
          // TemplateSelectorWin.getInstance().showThisWin(f, "FILERETURN", {"FILE_UUID":f.key, "USER_ID":user.userId}, this);
        } else {
          this.$message.success(this.$t('CargoMsg.Cargo_SendBackSuccess'))
        }
        this.returnDialog.visible = false
        this.successHandler(this.selectedFile.fileId)
      }
      )
    },
    returnValidate() {
      if (this.returnDialog.formData.companyCName === '') {
        this.$message.warning(this.$t('SeaExport.InputCustomerName'))
        return false
      }
      if (this.returnDialog.formData.receiver === '') {
        this.$message.warning(this.$t('SeaExport.InputRecipientName'))
        return false
      }
      if (this.returnDialog.formData.tel === '') {
        this.$message.warning(this.$t('SeaExport.InputContactNumberMark'))
        return false
      }
      if (this.returnDialog.formData.address === '') {
        this.$message.warning(this.$t('SeaExport.InputExpressAddress'))
        return false
      }
      if (this.returnDialog.formData.expressNo === '') {
        this.$message.warning(this.$t('SeaExport.InputReturnExpressNumber'))
        return false
      }
      if (!this.isLessThanBackDate()) {
        this.$message.warning(this.$t('SeaExport.ReturnDateGreaterThanRetrieveDate'))
        return false
      }
      return true
    },
    isLessThanBackDate() {
      for (const file of this.selectedFiles) {
        if (file.backDate && file.backDate > this.returnDialog.formData.returnDate) {
          return false
        }
      }
      return true
    },
    getCreditFileSetting() {
      const setting = cache.config.get('creditBlockFile')
      var d = {}
      var a = []
      a = setting.split(',')
      for (const o of a) {
        d[o.split('-')[0]] = o.split('-')[1]
      }

      return d
    },
    // =============================退还 end==================================
    // 快递信息
    onExInfo() {
      if (!this.checkEdit()) {
        this.$message.warning(this.$t('queryJob.YouToEditTheAdministrator'))
        return
      }
      this.fastMailDialog.visible = true
      this.fastMailDialog.exprssInfo = this.selectedFile
    },
    onReceipt() {
      this.templateSelectorDialog.cxt = new SeaExportJob(this.job)
      this.templateSelectorDialog.category = 'HUIZHIDAN'
      this.templateSelectorDialog.data = { 'jobuuid': this.job.uuid, 'JOB_UUID': this.job.uuid }
      this.templateSelectorDialog.visible = true
      // TemplateSelectorWin.getInstance().showThisWin(_job, "HUIZHIDAN", {"jobuuid":_job.key,"JOB_UUID":_job.key}, this);
    },
    onPrint() {
      this.selectedFiles = this.gridApi.getSelectedRows()
      if (this.selectedFiles.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      for (const file of this.selectedFiles) {
        if (!this.checkEdit(file)) {
          this.$message.warning(this.$t('queryJob.YouToEditTheAdministrator'))
          return
        }
      }
      const params = {}
      params.FILE_UUID = Array.from(this.selectedFiles, p => p.uuid)
      if (this.job) {
        params.jobuuid = this.job.uuid
      }
      this.templateSelectorDialog.cxt = new SeaExportJob(this.job)
      this.templateSelectorDialog.category = 'FileList'
      this.templateSelectorDialog.data = params
      this.templateSelectorDialog.visible = true
      // TemplateSelectorWin.getInstance().showThisWin(job, "FileList", params, this);
    },
    onRemove() {
      const rows = this.gridApi.getSelectedRows()
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      for (const file of rows) {
        if (!this.checkEdit(file)) {
          this.$message.warning('您没有编辑数据的相应权限,请联系管理员')
          return
        }
      }
      this.$confirm(this.$t('SeaExport.DeleteNumRecord').replace('{0}', rows.length), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        try {
          this.loading = getLoading()
          for (const item of rows) {
            await delFile(item.uuid)
          }
        } finally {
          this.loading.close()
          await this.reloadFileHandler()
          this.$nextTick(() => {
            this.onSelectionChanged()
          })
          this.$message.success(this.$t('common.tips.deleteSuccess'))
        }
      }).catch(() => {
      })
    },
    convertFileTypeNameByCodeLob(uuid) {
      const currentRow = this.rowData.find(x => x.uuid === uuid)
      if (currentRow) {
        return ColumnUtils.getFileTypeNameByCodeLob(this.job.lob, currentRow.fileType)
      }
      return ''
    },
    showAdvanceTextDialog(title, value, successCallback) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.visible = true
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    // 设置不可选日期范围
    disabledDate(currDate) {
      const start = ColumnUtils.dateLabelFunc(currDate)
      const end = ColumnUtils.dateLabelFunc(this.takeBackDialog.startDate)
      return start < end
    },
    /**
     * 根据当前用户权限加载文件
     */
    async reloadFileHandler() {
      if (this.role.viewAll || this.job.lob !== 'SE') {
        await this.loadFile(0)
      } else if (this.role.viewDep) {
        if (!this.role.departmentTeamUser || this.role.departmentTeamUser.length <= 0) {
          this.role.departmentTeamUser = await User.getUserDepartmentTeam()
        }
        await this.loadFile(1)
      } else if (this.role.viewUser) {
        // 加载 单证列表数据
        await this.loadFile(2)
      }
    },
    // 检查是否存在 编辑自己，编辑同组，编辑全部权限
    checkEdit(data = null) {
      // 没传数据 默认使用选中行
      if (!data) {
        data = this.selectedFile
      }
      // 有全部编辑权限情况
      if (this.role.editAll || this.job.lob !== 'SE') {
        return true
      } else {
        // 有编辑同组权限情况
        if (this.role.editDep && this.checkDepartmentTeam(data)) {
          return true
        } else if (this.role.editUser && data && data.inputBy === this.$store.getters.userId) {
          // 有编辑自己权限情况
          return true
        }
      }
      return false
    }
  }

}
</script>

<style lang="scss" scoped>
.file-from-bg{
  padding: 15px 0 60px 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  .file-form{
    width: 600px;
  }
}
</style>
